import React from "react";

const FAQsBannerVector = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 340 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4758_20467)">
        <path
          d="M25.8132 210.142H157.367L132.795 104.539L123.037 89.6173L113.457 50.7154L101.215 26.6459L57.0384 10.0371L51.982 13.5898L45.5951 33.9289L30.6922 59.0642L24.0391 73.2749L26.9664 110.4L27.2325 152.589V195.576L25.8132 210.142Z"
          fill="#897479"
        />
        <path
          d="M46.2175 210.142H177.771L144.949 102.673L134.127 87.4852L121.531 47.7839L107.337 23.3592L93.4101 9.2373L57.0399 10.0367L52.2497 30.731L39.387 56.3104L33.8871 70.7876L39.6531 108.624L43.2014 151.611L46.4836 195.309L46.2175 210.142Z"
          fill="#A58B90"
        />
        <path
          d="M67.5945 89.2615L84.1829 108.801L109.021 97.6103L133.859 107.913L135.545 90.3273L133.15 87.0411L120.819 48.4056L107.069 24.6026L93.5859 10.9248L58.1915 11.6353L53.4899 31.7968L44.7079 49.2938L50.4739 54.8005L67.5945 89.2615Z"
          fill="#AF959B"
        />
        <path
          d="M96.0725 158.717L85.8711 140.154L88.1775 120.969L86.4033 113.42L110.887 97.877L122.064 105.338L127.919 130.65L128.894 154.276L114.701 157.651L103.879 154.276L96.0725 158.717Z"
          fill="#AF959B"
        />
        <path
          d="M177.771 210.142L150.982 122.39L145.748 135.979L132.885 161.559L128.095 182.342L93.3214 183.763L77.7975 171.417L63.693 144.506L51.0077 104.893L40.1854 89.7057L34.1532 69.9883L33.8871 70.7876L39.6531 108.624L43.2014 151.611L46.4836 195.309L46.2175 210.142H177.771Z"
          fill="#9B8086"
        />
        <path
          d="M86.932 177.102L77.3515 172.927L69.7226 161.736L66.5292 187.937L65.9969 210.142H100.859L93.6738 185.983L86.932 177.102Z"
          fill="#A58B90"
        />
        <path
          d="M66.9761 155.697L64.3148 176.569L55.9763 166.799L48.3474 159.339L44.6217 157.385L42.6701 132.871L45.3313 118.483L42.2266 91.4824L50.299 105.604L53.8473 120.082L58.3714 134.559L65.9116 142.375L66.9761 155.697Z"
          fill="#A58B90"
        />
        <path
          opacity="0.44"
          d="M47.3711 73.1852C43.6454 80.113 42.847 82.511 43.3792 83.8433C43.9115 85.1756 47.9033 82.3334 48.2582 81.2676C48.7017 80.2018 48.3469 77.8037 48.3469 77.8037L55 83.2216C55 83.2216 68.04 109.778 68.3949 109.689C68.8384 109.511 59.7015 88.373 59.7015 88.373L64.8465 88.9947C64.8465 88.9947 79.4833 99.3863 79.9269 99.3863C80.3704 99.3863 68.7497 87.9289 68.7497 87.9289L77.4431 67.6786C77.4431 67.6786 90.217 67.4121 90.1283 66.968C90.0396 66.524 78.685 65.6358 78.685 65.6358L76.0237 61.2837C76.0237 61.2837 88.8864 59.9515 89.3299 59.5074C89.7735 59.0633 73.5399 58.4416 73.5399 58.4416L70.9674 55.8659C70.9674 55.8659 70.3464 41.2999 70.0803 41.0334C69.8142 40.767 70.169 57.3758 70.169 57.3758L56.4193 77.2708L51.2742 76.3827C51.2742 76.3827 46.1292 68.3003 45.8631 68.5667C45.5082 68.8332 47.3711 73.1852 47.3711 73.1852Z"
          fill="#FAFFF9"
        />
        <path
          opacity="0.69"
          d="M62.8947 133.492C61.8302 139.709 60.9431 147.259 62.6286 147.259C64.2253 147.259 62.8947 133.492 62.8947 133.492Z"
          fill="#FAFFF9"
        />
        <path
          opacity="0.69"
          d="M56.5959 125.321C56.4185 128.874 56.7733 133.137 58.4588 133.137C60.0555 133.137 56.5959 125.321 56.5959 125.321Z"
          fill="#FAFFF9"
        />
        <path
          opacity="0.69"
          d="M72.6499 116.884C72.4724 120.436 72.8273 124.7 74.5127 124.7C76.1095 124.789 72.6499 116.884 72.6499 116.884Z"
          fill="#FAFFF9"
        />
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M173.069 206.411L174.665 199.927L146.367 107.291C144.061 111.554 142.021 115.64 140.335 119.37C140.069 119.992 139.803 120.614 139.537 121.235C136.343 128.518 134.214 134.824 132.795 140.331C132.795 140.42 132.795 140.509 132.706 140.597C132.529 141.219 132.352 141.841 132.263 142.463C132.263 142.551 132.174 142.729 132.174 142.818C131.997 143.44 131.908 143.972 131.819 144.594C131.819 144.683 131.731 144.772 131.731 144.949C129.779 154.009 129.779 160.581 129.247 165.733L131.021 165.466C125.965 184.118 122.682 201.615 121.618 207.388C119.134 208.187 114.965 210.23 114.965 210.23H123.215C123.215 210.23 124.013 208.276 123.481 207.477L141.843 177.368L142.553 181.631L147.166 178.256L147.875 182.341L153.375 175.769L155.15 183.407L159.762 178.522L161.359 185.539L167.569 179.677C169.165 192.733 171.028 203.391 171.649 206.944C170.407 208.01 169.875 210.23 169.875 210.23H176.794C176.439 210.141 174.665 207.033 173.069 206.411Z"
            fill="#843131"
          />
          <path
            opacity="0.6"
            d="M121.973 77.8931C117.893 75.3174 116.119 72.2976 115.143 70.3436C114.965 69.9884 114.788 69.7219 114.699 69.4555C114.611 69.3666 114.611 69.2778 114.522 69.189C114.522 69.189 114.522 69.189 114.522 69.1002C114.522 69.0114 114.433 68.9226 114.433 68.8337C114.433 68.8337 114.433 68.8337 114.433 68.7449C114.344 68.6561 114.344 68.5673 114.344 68.5673C114.344 68.4785 114.256 68.4785 114.256 68.4785L114.167 68.3896C114.078 68.3896 114.078 68.3896 113.99 68.3896C112.393 68.7449 110.796 70.6989 110.707 71.7647C110.53 73.7187 111.328 75.495 112.216 76.9161C112.482 77.2714 112.659 77.6266 112.925 77.8931C113.014 78.0707 113.191 78.1595 113.28 78.3372C113.457 78.6036 113.724 78.8701 113.901 79.1365C114.167 79.4918 114.344 79.7582 114.433 80.0247C114.433 80.1135 114.522 80.2911 114.611 80.6464C114.611 80.824 114.699 81.0905 114.788 81.3569C114.699 81.5346 114.699 81.6234 114.611 81.801C114.522 81.8898 114.433 81.9787 114.344 82.0675L114.256 82.1563C114.167 82.2451 114.078 82.2451 113.99 82.3339C113.901 82.3339 113.901 82.4228 113.812 82.4228C113.724 82.5116 113.546 82.5116 113.457 82.6004C113.457 82.5116 113.457 82.4227 113.369 82.3339C113.369 82.2451 113.28 82.2451 113.28 82.1563C113.28 82.1563 113.28 82.1563 113.191 82.1563L113.103 82.0675C113.014 82.0675 112.925 82.0675 112.836 82.0675C110.619 82.3339 106.449 83.5774 105.296 83.6662C104.32 83.755 104.498 88.7288 105.917 88.3735C106.095 88.3735 106.272 88.2847 106.538 88.2847C106.627 88.4623 106.627 88.7288 106.716 88.9064C106.272 88.9952 105.917 89.1728 105.74 89.3505C104.764 90.061 105.03 93.7913 106.538 93.969C106.982 94.0578 107.603 93.969 108.401 93.7913C108.49 94.0578 108.667 94.4131 108.756 94.6795C108.578 94.7683 108.401 94.8571 108.224 94.8571C107.07 95.5677 107.248 98.7651 108.667 99.2092C109.111 99.298 110.264 99.1204 111.506 98.8539C112.925 99.298 115.232 99.1204 117.627 98.4098C119.49 97.8769 121.441 96.9887 123.215 95.5677C128.183 96.367 136.521 97.7881 142.287 98.5875L134.481 87.663L131.997 79.7582C129.159 80.0247 126.497 80.2023 124.368 80.38C123.57 79.3141 122.86 78.5148 121.973 77.8931Z"
            fill="#843131"
          />
        </g>
        <path
          d="M212.188 172.838L220.171 178.7L219.994 169.729L212.188 172.838Z"
          fill="#994A31"
        />
        <path
          d="M187.797 133.848C195.337 167.953 211.748 207.743 211.748 207.743H213.256L221.594 137.578L187.797 133.848Z"
          fill="#FFB882"
        />
        <path
          d="M215.385 189.27L221.505 137.578L187.797 133.848C191.788 151.611 198.087 170.973 203.232 185.362C207.224 185.806 211.393 187.049 215.385 189.27Z"
          fill="#FF9566"
        />
        <path
          d="M139.984 156.141L147.081 155.341L142.557 147.525L139.984 156.141Z"
          fill="#994A31"
        />
        <path
          d="M146.101 135.269C138.916 169.374 138.117 209.164 138.117 209.164H139.625L178.213 138.999L146.101 135.269Z"
          fill="#FFB882"
        />
        <path
          d="M153.553 183.852L178.214 138.999L146.101 135.269C143.529 147.348 141.843 160.137 140.602 171.595C145.126 174.17 149.65 178.345 153.553 183.852Z"
          fill="#FF9566"
        />
        <path
          d="M198.706 77.9816C180.965 81.4455 162.691 76.6494 140.425 71.8533C127.74 69.1887 134.57 52.3135 144.328 51.4253C158.344 50.2707 197.553 43.6982 202.875 45.3857C216.093 49.8266 220.972 73.6296 198.706 77.9816Z"
          fill="#FFB882"
        />
        <path
          d="M153.11 50.4485C131.998 50.8038 104.676 53.2906 104.676 53.2906L108.579 70.1659C108.579 70.1659 139.449 72.2975 149.562 73.0969C163.134 74.2515 160.295 50.3597 153.11 50.4485Z"
          fill="#FFB882"
        />
        <path
          d="M209.706 50.1816C210.416 57.6423 203.053 55.4218 191.255 57.8199C174.844 61.0173 161.005 67.6786 140.78 63.593C130.312 62.4384 112.305 61.1061 106.273 60.3068L108.579 70.2543C108.579 70.2543 131.998 73.4517 144.772 74.8728C164.997 79.0472 182.207 81.2676 198.618 78.0702C216.448 74.4287 216.98 58.6193 209.706 50.1816Z"
          fill="#FF9566"
        />
        <path
          d="M188.415 46.9844C164.819 53.5569 154.617 74.6065 154.617 74.6065L156.48 74.5177L151.69 82.2448L153.908 81.6231C133.948 122.301 139.182 142.907 139.981 156.141L144.771 150.456L145.303 159.516L149.295 154.986L149.738 166.266L158.52 163.601L163.045 175.503L168.988 171.417L170.94 176.391L177.504 168.397L181.762 177.634L187.617 171.506L191.52 179.766L201.278 170.44L211.568 179.588L215.116 171.417L220.172 178.789C230.729 125.144 241.817 71.5868 227.801 58.5306C222.39 53.4681 196.842 44.6752 188.415 46.9844Z"
          fill="#FFB640"
        />
        <path
          d="M228.425 55.5999C226.208 54.5341 221.684 54.5341 216.627 52.5801C210.506 61.9947 205.007 78.6035 199.507 102.495C194.362 124.966 191.346 149.48 187.265 171.684L191.168 180.21L201.192 171.151L211.482 180.299L215.208 172.306L220.176 178.612C233.304 118.482 246.522 64.6592 228.425 55.5999Z"
          fill="#FFAC33"
        />
        <path
          d="M214.499 147.081L210.418 143.44L202.878 150.989L201.37 140.953L194.362 145.305L191.435 139.354L186.024 146.016L184.072 137.844L175.911 141.664L176.355 134.913L170.145 138.288L169.968 133.759C169.968 133.848 169.879 133.848 169.879 133.936C167.839 138.733 167.75 141.486 167.75 141.486L174.226 137.4L173.427 143.973L182.564 139.976L185.314 149.568L191.08 142.463L193.298 147.792L199.596 143.795L201.636 153.831L210.862 145.749L214.233 148.325L218.225 146.193L214.499 147.081Z"
          fill="#FFA42C"
        />
        <path
          d="M144.86 109.423L153.642 105.071L153.465 118.038L160.118 109.245L160.65 116.44L167.037 111.821L166.239 125.321L176.085 115.551L178.303 119.282L182.206 116.884L179.013 117.683L176.529 112.443L168.19 121.591L169.432 108.268L162.336 113.242L161.36 105.071L155.15 113.242L155.594 102.229L147.699 106.403L149.739 97.5215L146.013 99.8307C145.747 100.541 145.481 101.341 145.215 102.051L147.255 100.541L144.86 109.423Z"
          fill="#FFA42C"
        />
        <path
          d="M159.229 84.2874L167.567 82.2446L163.398 90.8599L175.906 85.8861L177.148 88.373L181.228 87.396L178.124 87.5736L177.059 84.1098L166.414 88.8171L170.938 80.4683L161.89 82.5999L162.777 76.8268L153.019 81.3564L157.898 74.4287L154.527 74.5175C154.439 74.6952 154.35 74.784 154.35 74.784L156.213 74.6952L151.423 82.4223L153.64 81.8005C153.463 82.067 153.374 82.3334 153.197 82.6887L160.116 79.4025L159.229 84.2874Z"
          fill="#FFA42C"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M182.475 151.345C180.612 151.078 178.483 152.233 178.217 154.098C178.128 154.631 178.217 155.164 178.306 155.697C178.572 157.029 179.015 158.361 179.725 159.516C181.499 162.269 187.975 165.733 190.015 161.381C191.701 157.651 185.846 151.878 182.475 151.345Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M168.544 140.154C168.012 139.532 167.214 139.266 166.415 139.266C165.617 139.266 164.819 139.443 164.02 139.621C163.666 139.71 163.133 139.887 163.045 140.243C162.956 140.509 163.045 140.687 163.133 140.953C163.577 142.285 164.109 143.618 165.262 144.417C166.415 145.216 168.19 145.128 168.899 143.884L168.722 144.328C169.609 143.973 169.432 142.729 169.254 141.841C169.077 141.22 168.899 140.598 168.544 140.154Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M185.222 135.979C185.399 136.157 185.665 136.157 185.843 136.157C186.907 136.246 188.149 136.157 188.77 135.269L188.947 135.446C189.48 135.535 189.923 135.002 189.923 134.558C189.923 134.025 189.746 133.581 189.48 133.137C189.036 132.427 188.415 131.716 187.617 131.361C186.818 131.006 185.843 131.006 185.222 131.539C184.69 131.983 184.512 132.782 184.512 133.492C184.512 134.203 184.778 134.914 185.044 135.535C185.044 135.713 185.044 135.891 185.222 135.979Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M163.847 120.703C165.444 120.437 166.686 118.572 166.863 117.062C167.129 115.108 166.242 113.065 164.912 111.555C163.936 110.4 162.428 109.423 160.92 109.601C157.283 109.956 160.299 116.173 161.097 118.039C161.807 119.549 161.984 120.97 163.847 120.703Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M143.974 131.272C145.216 129.496 145.393 127.276 145.482 125.233C145.57 122.391 145.393 119.637 144.949 116.795C144.772 115.907 143.974 112.976 142.643 110.312C140.159 119.282 139.095 126.743 138.829 133.226C140.691 133.848 142.909 132.871 143.974 131.272Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M166.149 84.4654C164.286 85.4424 162.778 86.8635 161.27 88.2845C160.294 89.1727 159.229 90.3273 159.407 91.6596C159.407 91.8372 159.495 91.926 159.584 92.0148C161.003 93.0806 165.528 90.505 167.036 90.0609C168.544 89.6168 170.495 89.6168 171.826 88.8174C173.068 88.0181 174.132 85.9753 173.156 84.5542C171.826 82.5114 167.834 83.5772 166.149 84.4654Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M163.312 70.8765C165.264 68.9226 167.126 66.7909 168.546 64.3929C169.61 62.5277 170.231 59.8632 168.546 58.4421C168.368 58.2645 168.102 58.1757 167.925 57.998C158.788 65.9028 154.619 74.518 154.619 74.518L156.481 74.4292L151.869 81.8899C152.933 81.0905 153.998 80.1135 154.973 79.1365C157.812 76.472 160.562 73.7187 163.312 70.8765Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M190.812 90.682C188.328 92.0143 186.997 96.7216 186.199 99.2085C184.957 103.116 184.78 107.291 185.756 111.199C187.175 117.327 191.344 122.834 196.844 125.854C197.288 126.12 197.731 126.298 198.263 126.209C199.062 126.031 199.328 125.143 199.417 124.344C200.481 118.215 201.102 111.998 200.215 105.87C199.771 102.672 195.957 87.8399 190.812 90.682Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M145.304 146.105C142.821 147.437 141.49 152.144 140.692 154.631C140.603 154.987 140.514 155.342 140.425 155.697L144.861 150.457L145.393 159.516L149.385 154.987L149.828 166.266L155.151 164.668C155.062 163.602 154.974 162.447 154.796 161.381C154.264 158.095 150.449 143.263 145.304 146.105Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M212.812 160.582C213.167 160.316 213.256 159.871 213.256 159.516C213.344 158.362 213.078 157.207 212.812 156.141C212.28 154.01 211.57 151.967 210.772 150.013C210.594 149.569 210.328 149.036 209.796 148.947C209.264 148.858 208.82 149.391 208.731 149.924V148.414C208.643 149.569 208.554 150.723 208.643 151.878V150.99C208.643 151.345 208.643 151.611 208.643 151.967C208.82 154.631 209.618 157.385 210.949 159.694C211.393 160.227 212.191 161.026 212.812 160.582Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M208.641 151.878C208.73 151.878 208.641 151.878 208.641 151.878C208.641 151.789 208.641 151.789 208.641 151.789V151.878Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M198.175 140.065C196.667 139.443 194.892 140.509 194.183 141.93C193.473 143.351 193.562 145.128 193.828 146.637C194.094 148.059 194.715 151.167 196.578 151.522C198.796 151.878 198.263 150.101 198.441 148.858C198.796 146.46 202.166 141.664 198.175 140.065Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M210.149 139.533C210.682 139.444 210.948 138.822 211.036 138.289C211.569 136.069 211.48 133.582 210.682 131.362C210.415 130.562 209.883 129.585 208.996 129.408C207.932 129.141 206.956 130.118 206.778 131.184C206.69 131.45 206.69 131.717 206.69 131.895L206.512 131.184C205.182 134.026 206.424 137.668 209.085 139.178C209.528 139.444 209.883 139.533 210.149 139.533Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M226.739 120.259C223.989 122.035 222.304 125.144 221.772 128.341C221.24 131.539 221.772 134.825 222.836 137.934C223.812 140.953 225.32 143.884 227.183 146.549C229.135 137.223 230.997 128.341 232.594 119.904C232.239 119.637 231.796 119.46 231.352 119.371C229.755 118.838 228.07 119.371 226.739 120.259Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M234.188 101.607C233.656 101.518 232.946 101.518 232.503 101.962C232.148 102.317 232.059 102.85 231.971 103.294C231.705 105.337 231.882 107.647 234.011 108.535C234.188 108.624 234.277 108.624 234.454 108.624C234.809 106.403 235.164 104.271 235.43 102.14C235.164 101.962 234.898 101.785 234.543 101.696C234.454 101.696 234.277 101.607 234.188 101.607Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M228.247 65.8142C226.916 69.1893 223.634 81.446 230.642 81.8013C234.279 81.9789 236.053 76.9164 236.94 72.0314C236.408 67.1465 235.255 63.1497 233.392 60.2188C232.682 60.3076 231.972 60.574 231.351 61.0181C229.755 62.1727 228.868 64.0379 228.247 65.8142Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M220.175 164.401C218.401 163.424 216.183 164.934 215.119 166.71C213.788 168.753 213.167 171.151 212.812 173.638C212.635 175.148 212.458 176.658 212.458 178.168L215.119 172.395L220.086 178.701C220.885 174.97 221.683 171.24 222.482 167.599C222.127 166.799 221.772 166.089 221.24 165.467C220.974 165.023 220.619 164.668 220.175 164.401Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M172.806 164.401C172.008 163.779 170.943 163.779 169.968 163.779C168.726 163.779 167.573 163.957 166.419 164.401C165.266 164.845 164.29 165.733 163.936 166.888C163.669 167.687 163.669 168.575 163.847 169.464C164.024 171.062 164.468 172.572 165.177 174.082L168.992 171.418L170.943 176.391L174.758 171.773C174.669 170.263 174.492 168.753 174.226 167.243C173.959 166.089 173.605 165.023 172.806 164.401Z"
            fill="#5E2A3A"
          />
        </g>
        <path
          d="M186.909 85.2643C192.853 115.817 207.933 137.045 223.812 134.114C226.739 132.249 242.086 72.0305 229.489 60.4843C223.989 55.4217 197.554 45.119 188.683 47.6058C188.595 47.6058 188.506 47.6058 188.506 47.6946C185.933 58.6192 184.159 71.1424 186.909 85.2643Z"
          fill="#E03F3F"
        />
        <path
          d="M188.504 84.2872C194.537 114.307 207.931 134.469 223.278 131.449C226.028 129.584 239.6 70.6094 227.358 59.4184C222.036 54.5335 196.754 44.5859 188.416 46.8952C188.327 46.8952 188.327 46.8952 188.238 46.984C185.843 57.5533 185.754 70.6094 188.504 84.2872Z"
          fill="#FF865C"
        />
        <path
          d="M190.368 84.2875C196.046 112.709 208.731 131.716 223.279 128.963C225.94 127.186 238.714 71.409 227.093 60.8398C222.037 56.2213 198.174 46.8067 190.279 49.0271C190.191 49.0271 190.191 49.0271 190.102 49.1159C187.884 58.9746 187.707 71.3202 190.368 84.2875Z"
          fill="#FFB882"
        />
        <path
          d="M228.422 58.797C223.1 53.912 196.842 44.6751 188.415 46.9843C188.326 46.9843 188.326 46.9843 188.238 47.0731C186.818 53.1127 186.286 65.103 187.617 73.2742C197.729 74.7841 216.713 84.554 215.116 130.828C217.777 131.716 220.527 131.982 223.366 131.449C226.116 129.673 240.664 69.8991 228.422 58.797Z"
          fill="#FF865C"
        />
        <path
          d="M231.885 94.3243C229.312 99.4757 222.659 109.157 214.232 111.555C202.345 114.841 196.313 104.627 200.127 97.9658C205.627 88.4624 218.401 75.6727 222.304 73.6299C230.998 69.1002 237.739 82.6004 231.885 94.3243Z"
          fill="#FFB882"
        />
        <path
          d="M229.399 59.8623C241.375 88.8167 213.165 94.4122 206.246 96.3661C202.432 97.4319 203.496 109.866 201.012 108.623C203.408 111.909 207.932 113.952 214.053 112.264C222.48 109.866 230.464 100.274 233.036 95.1227C237.649 85.9745 236.318 73.8954 233.391 66.4348C232.238 63.5038 230.907 61.5498 229.399 59.8623Z"
          fill="#FF9566"
        />
        <path
          opacity="0.6"
          d="M179.899 53.2017L175.996 61.5505L180.431 59.1525L177.061 65.8138L180.698 64.3927L179.988 71.9421L183.181 70.3434L180.698 75.4948L185.754 73.6297L185.044 77.4488C187.085 77.4488 189.125 77.36 190.988 77.1823L188.859 78.9587C188.859 78.9587 194.891 79.0475 199.149 77.0047L197.197 79.4028C197.197 79.4028 203.496 78.337 207.133 75.3172L204.737 79.2251C204.737 79.2251 212.278 76.2942 217.334 72.2974L215.649 77.0935C215.649 77.0935 225.229 71.498 228.245 65.2809L234.987 71.5869L235.342 64.1262C234.011 61.0176 231.261 56.932 228.689 55.5998C226.56 54.534 222.213 54.534 217.423 52.6688C207.931 48.7609 195.334 48.0503 189.835 46.9845C185.31 46.1852 183.093 46.8069 180.875 47.0733L177.593 54.0899L179.899 53.2017Z"
          fill="#843131"
        />
        <path
          d="M246.61 42.2769C243.416 39.1683 239.957 34.017 238.715 30.7307L240.489 30.6419C240.489 30.6419 239.158 25.4017 235.61 20.0727C237.65 20.872 239.779 21.9378 241.554 23.0036C238.005 18.2075 234.723 15.4542 231.263 13.7667C233.304 12.8785 235.433 12.1679 237.207 11.8127C232.239 9.50343 228.336 9.50343 224.699 10.8357C223.635 10.3916 222.57 10.0363 221.506 9.76988C222.836 7.46064 225.143 4.70731 227.272 2.93096C221.683 4.1744 218.489 6.30602 216.183 9.14816C215.562 9.14816 215.03 9.14816 214.409 9.23698C214.675 6.39483 214.231 3.46387 212.723 0C212.191 3.19742 210.683 7.46064 209.086 10.4804C208.998 10.4804 208.909 10.4804 208.909 10.5692C204.207 8.79289 200.393 8.97053 194.893 11.0133C196.756 11.0133 200.304 12.1679 203.498 13.3226C203.32 13.4114 203.143 13.589 202.966 13.6778C199.506 12.7897 195.603 12.9673 190.369 15.2765C192.942 15.4542 196.046 16.1647 198.441 17.0529C198.087 17.3193 197.732 17.5858 197.377 17.9411C194.095 18.1187 190.635 19.4509 186.555 22.5595C188.417 22.2043 190.813 22.0266 192.942 22.1155C191.167 23.8918 189.571 25.6681 187.974 27.3557C185.579 28.3327 182.297 29.132 179.724 29.3985C181.587 30.109 183.361 30.4643 184.869 30.7307C182.208 33.6617 179.813 36.0597 177.773 37.392L180.789 39.0795L177.152 46.5402L180.522 44.4086L175.644 54.4449L180.256 51.958L176.797 59.0634L180.522 57.5535L179.813 65.547L183.184 63.8595L180.522 69.3662L185.845 67.3234L185.135 71.409C187.264 71.409 189.393 71.3201 191.345 71.1425L189.127 73.0077C189.127 73.0077 195.425 73.0965 199.861 70.9649L197.821 73.4518C197.821 73.4518 204.385 72.2971 208.199 69.0997L205.716 73.1853C205.716 73.1853 213.611 70.0767 218.844 65.8135L217.07 70.8761C217.07 70.8761 227.094 64.9253 230.199 58.3528L234.368 65.6358L237.118 53.2015L240.666 56.6653C241.021 52.935 240.4 45.2079 239.868 39.1683C241.465 40.4118 243.771 41.3888 246.61 42.2769Z"
          fill="#753949"
        />
        <path
          d="M184.692 71.32H190.635L193.829 69.0996L184.692 71.32Z"
          fill="#5E2A3A"
        />
        <path
          d="M180.078 69.2774L185.401 67.5899L185.844 65.9023L180.078 69.2774Z"
          fill="#5E2A3A"
        />
        <path
          d="M247.32 42.8102C244.126 39.7016 240.755 34.5502 239.514 31.1751L241.465 30.8198C241.465 30.8198 239.247 25.402 235.61 20.073C237.651 20.8723 239.78 21.9381 241.554 23.0039C238.005 18.2078 234.635 16.165 231.175 15.9874C220.441 15.3657 227.893 41.6555 210.95 58.2643C203.853 65.1921 196.49 70.3435 189.039 72.8303L188.773 73.008C188.773 73.008 195.071 73.0968 199.506 70.9652L197.466 73.4521C197.466 73.4521 204.03 72.2974 207.845 69.1L205.361 73.1856C205.361 73.1856 213.256 70.077 218.49 65.8138L216.716 70.8764C216.716 70.8764 226.828 65.6362 229.933 59.1525L234.102 66.5243L237.118 54.0899L240.844 57.3762C241.199 53.6458 240.667 45.9188 240.134 39.8792C241.909 41.1226 244.481 41.922 247.32 42.8102Z"
          fill="#5E2A3A"
        />
        <path
          d="M221.237 101.873C220.528 88.9949 213.609 74.0737 214.318 62.7051L200.391 68.0341C200.391 68.0341 196.754 91.1266 198.617 101.252C202.609 122.39 221.681 109.245 221.237 101.873Z"
          fill="#FFB882"
        />
        <path
          d="M215.652 62.1719L212.724 63.3265C213.079 74.251 217.958 89.2611 218.401 100.807C218.668 107.824 201.813 116.794 198.176 97.2546C198.265 98.6757 198.442 100.097 198.62 101.251C202.611 122.39 223.28 110.222 222.837 102.85C222.127 89.9716 215.031 73.5405 215.652 62.1719Z"
          fill="#FF9566"
        />
        <path
          d="M193.475 29.043C191.435 29.9311 191.79 33.4838 194.806 34.372C198.088 35.349 202.789 33.3062 202.789 33.3062L193.475 29.043Z"
          fill="#FF9566"
        />
        <path
          d="M194.006 29.1318C192.41 29.8424 192.676 32.6845 195.071 33.3951C197.732 34.1944 201.547 32.5069 201.547 32.5069L194.006 29.1318Z"
          fill="#FFB882"
        />
        <path
          d="M216.271 37.3917C215.562 44.4082 209.263 41.6549 207.667 40.7667C202.876 38.191 199.86 32.3291 199.86 32.3291L216.271 37.3917Z"
          fill="#FF9566"
        />
        <path
          d="M212.9 37.1259C212.368 42.1885 207.844 40.1457 206.779 39.5239C203.319 37.6588 201.19 33.4844 201.19 33.4844L212.9 37.1259Z"
          fill="#FFB882"
        />
        <path
          d="M205.003 33.9277C204.825 34.8159 205.003 35.8817 206.333 36.3258C207.664 36.7699 207.841 34.9935 207.841 34.9935L205.003 33.9277Z"
          fill="#471F2C"
        />
        <path
          d="M196.756 30.1982C196.578 31.0864 196.756 32.1522 198.086 32.5963C199.417 33.0404 199.594 31.264 199.594 31.264L196.756 30.1982Z"
          fill="#471F2C"
        />
        <path
          d="M223.279 34.6389C209.441 36.5929 189.836 26.3789 189.836 26.3789C195.513 31.175 210.505 38.458 223.9 38.8133L223.279 34.6389Z"
          fill="#5E2A3A"
        />
        <path
          d="M200.747 34.4615C194.715 31.4418 187.441 33.9286 187.441 33.9286C187.441 33.9286 193.65 36.3267 197.908 36.9484C202.078 37.5701 200.747 34.4615 200.747 34.4615Z"
          fill="#5E2A3A"
        />
        <path
          d="M200.212 34.9058C194.092 32.0636 186.906 34.8169 186.906 34.8169C186.906 34.8169 193.205 36.9486 197.462 37.4815C201.632 38.0144 200.212 34.9058 200.212 34.9058Z"
          fill="#753949"
        />
        <path
          d="M201.011 33.1292C199.059 32.5075 197.817 32.6851 197.64 33.8398C197.463 34.9944 198.172 36.149 199.592 36.5931C201.1 37.126 203.495 36.5043 203.495 36.5043L201.011 33.1292Z"
          fill="#EA7B59"
        />
        <path
          d="M201.367 33.484C199.681 33.0399 198.528 33.2175 198.439 34.0169C198.35 34.8163 198.883 35.7932 200.036 36.1485C201.278 36.5926 203.584 36.2373 203.584 36.2373L201.367 33.484Z"
          fill="#FFB882"
        />
        <path
          d="M198.974 37.2146C198.264 36.9481 197.555 36.9481 196.934 37.1258C197.022 37.3034 197.111 37.481 197.2 37.6587C197.555 37.481 197.998 37.3922 198.442 37.5698C200.038 38.1027 201.014 41.1225 199.595 42.4548L200.393 43.2541C202.522 41.3002 201.369 37.9251 198.974 37.2146Z"
          fill="#4F2031"
        />
        <path
          d="M198.885 40.2341C198.974 39.8788 198.53 39.5236 197.909 39.4347C197.289 39.3459 196.579 39.5236 196.49 39.8788C196.401 40.2341 196.934 40.0565 197.555 40.1453C198.264 40.1453 198.797 40.5005 198.885 40.2341Z"
          fill="#4F2031"
        />
        <path
          d="M222.126 35.1719L217.07 43.6095C218.578 46.8957 219.731 54.2676 219.731 54.2676C222.304 50.182 223.279 44.6753 222.126 35.1719Z"
          fill="#753949"
        />
        <path
          d="M219.198 42.8096L212.367 49.8261C212.988 53.3788 212.456 60.8394 212.456 60.8394C215.827 57.4644 218.045 52.4018 219.198 42.8096Z"
          fill="#753949"
        />
        <path
          d="M224.522 20.5166L221.062 29.6648C223.103 32.6845 225.587 39.7011 225.587 39.7011C227.361 35.2602 227.361 29.6648 224.522 20.5166Z"
          fill="#753949"
        />
        <path
          d="M223.723 12.9668L223.9 22.8255C226.916 24.8683 231.795 30.4638 231.795 30.4638C231.795 25.6676 229.666 20.5163 223.723 12.9668Z"
          fill="#753949"
        />
        <path
          d="M217.868 29.3986C208.643 33.2178 192.32 27.9775 192.32 27.9775C197.82 31.2638 209.352 34.3724 218.046 32.3296L217.868 29.3986Z"
          fill="#5E2A3A"
        />
        <path
          d="M194.894 23.8027C199.241 30.6417 206.959 34.0167 206.959 34.0167C203.854 33.4838 196.225 28.51 193.652 24.6021L194.894 23.8027Z"
          fill="#5E2A3A"
        />
        <path
          d="M226.473 45.7411C228.336 47.0734 230.642 46.1852 231.263 44.32C231.884 42.4549 230.11 40.4121 228.158 40.0568C226.207 39.5239 226.473 45.7411 226.473 45.7411Z"
          fill="#FF865C"
        />
        <path
          d="M227.096 44.7642C228.249 45.5636 229.668 45.0307 230.023 43.8761C230.378 42.7215 229.313 41.478 228.072 41.2116C226.918 40.9451 227.096 44.7642 227.096 44.7642Z"
          fill="#CE5236"
        />
        <path
          d="M226.827 43.9646C227.537 44.4975 228.424 44.1422 228.601 43.4317C228.867 42.7212 228.158 42.0106 227.448 41.833C226.738 41.6554 226.827 43.9646 226.827 43.9646Z"
          fill="#FF865C"
        />
        <path
          d="M203.676 35.9707C210.152 37.6582 213.966 44.3195 213.966 44.3195C213.966 44.3195 207.757 42.0103 204.208 39.701C200.66 37.3918 203.676 35.9707 203.676 35.9707Z"
          fill="#5E2A3A"
        />
        <path
          d="M203.319 36.415C209.706 38.2802 213.343 45.1191 213.343 45.1191C213.343 45.1191 207.222 42.6322 203.674 40.1454C200.214 37.7473 203.319 36.415 203.319 36.415Z"
          fill="#753949"
        />
        <path
          d="M141.135 210.141H129.071C129.071 210.141 136.257 206.943 139.361 206.41C142.377 205.877 141.135 210.141 141.135 210.141Z"
          fill="#FFB882"
        />
        <path
          d="M219.288 210.141H209.176C209.176 210.141 209.797 206.145 212.281 205.612C214.853 204.99 219.288 210.141 219.288 210.141Z"
          fill="#FFB882"
        />
        <path
          d="M198.087 69.4548C203.764 67.2344 208.643 60.3067 208.465 53.4678C205.449 60.4843 202.788 65.014 198.087 69.4548Z"
          fill="#5E2A3A"
        />
        <path
          d="M217.865 68.7448L198.793 68.123C199.502 72.2086 199.236 79.1364 198.438 81.1792L211.921 84.9095C211.921 84.9095 213.341 73.8962 217.865 68.7448Z"
          fill="#FFB882"
        />
        <path
          d="M213.608 72.6531C214.672 71.5873 216.89 71.4097 218.575 68.7451C223.809 60.574 217.866 61.2845 217.067 59.9523C215.648 57.7318 217.334 52.314 216.535 51.2482C214.938 48.9389 203.584 53.1133 200.656 54.6232C197.729 56.1331 196.044 65.2813 199.326 71.4985C200.568 73.8077 213.608 72.6531 213.608 72.6531Z"
          fill="#FFB882"
        />
        <path
          d="M205.802 55.6003C202.963 56.3109 199.592 56.9326 197.641 64.3044C197.463 59.7747 198.528 54.8898 200.391 53.824C203.318 52.3141 214.85 48.1397 216.447 50.3601C216.536 50.4489 215.382 57.9984 215.382 58.176C211.391 57.0214 210.149 54.6233 205.802 55.6003Z"
          fill="#FFB882"
        />
        <path
          d="M216.534 56.2219C216.445 57.643 216.534 59.064 217.066 59.9522C217.865 61.2845 222.123 53.1133 226.292 53.1133C227.445 53.1133 229.397 54.9784 229.663 56.9324C229.84 58.2647 223.719 59.4193 218.574 68.7451C216.002 73.3636 211.034 73.63 206.954 73.63C205.357 71.0543 204.559 67.7681 206.421 64.5707C208.107 61.6397 214.316 58.087 216.534 56.2219Z"
          fill="#FFB882"
        />
        <path
          d="M211.034 57.7312C210.857 53.912 210.946 50.0929 210.502 48.9383C210.059 47.6948 205.889 47.5172 205.268 49.4712C204.559 51.6916 205.002 59.0634 205.357 59.5963C205.801 60.1292 211.123 59.9516 211.034 57.7312Z"
          fill="#FFB882"
        />
        <path
          d="M204.382 59.597C204.293 58.2648 204.293 52.5805 203.938 51.4259C203.494 49.916 199.857 50.1824 199.148 52.0476C198.438 53.7351 199.237 61.7287 199.591 62.1727C199.946 62.7056 204.47 61.6398 204.382 59.597Z"
          fill="#FFB882"
        />
        <path
          d="M216.358 56.9323C216.979 54.1789 217.333 48.8499 217.688 47.4288C217.954 46.2742 220.616 39.9682 220.261 39.1688C219.906 38.3695 217.866 36.1491 216.801 37.3037C215.737 38.5471 212.632 45.6525 212.366 47.4288C212.1 49.294 210.946 55.1559 211.301 55.6888C211.567 56.3106 216.003 58.8862 216.358 56.9323Z"
          fill="#FFB882"
        />
        <path
          d="M107.515 50.7139L112.571 71.5859C116.741 69.5431 124.37 67.7668 126.853 68.0332C126.942 68.0332 114.523 54.0001 107.515 50.7139Z"
          fill="#FF9566"
        />
        <path
          d="M113.104 54.0896C111.685 53.2902 110.798 50.8921 107.338 49.8263C96.8704 46.6289 100.596 53.0238 99.3542 54.356C97.314 56.5764 89.8625 56.2212 88.9754 57.3758C87.0238 59.8627 95.0075 70.876 97.4914 73.5405C100.064 76.205 110.443 75.3169 116.209 69.899C118.249 67.945 113.104 54.0896 113.104 54.0896Z"
          fill="#FF9566"
        />
        <path
          d="M94.9169 68.3888C96.5136 71.3198 100.239 74.1619 108.933 73.9843C104.054 75.4942 98.3765 75.8494 96.7798 74.1619C94.2072 71.4974 86.2235 60.2176 88.1751 57.7307C88.2638 57.6419 96.7798 56.5761 96.9572 56.4873C87.909 59.4183 92.5218 63.9479 94.9169 68.3888Z"
          fill="#FFB882"
        />
        <path
          d="M98.8235 52.3132C97.759 50.8921 91.8155 46.8953 91.5494 42.2768C91.4607 41.0334 93.4123 38.6353 95.63 38.1912C97.138 37.9248 98.8235 44.6749 109.735 49.8263C115.146 52.402 115.767 57.9975 116.033 62.616C113.283 64.6587 109.646 65.8134 105.92 63.9482C102.549 62.1719 99.4444 53.1125 98.8235 52.3132Z"
          fill="#FFB882"
        />
        <path
          d="M98.1984 61.1062C93.9405 62.1721 88.9728 62.6161 87.8196 63.4155C86.5777 64.2148 87.7309 68.8333 90.0373 69.011C92.7873 69.2774 100.948 66.9682 101.481 66.4353C102.013 65.9024 100.594 60.4845 98.1984 61.1062Z"
          fill="#FFB882"
        />
        <path
          d="M101.747 68.1223C100.239 68.4776 94.0299 69.6322 92.788 70.2539C91.2799 71.0533 92.2557 75.0501 94.3847 75.4941C96.425 75.9382 105.03 73.4513 105.562 72.9184C106.094 72.3855 103.965 67.5894 101.747 68.1223Z"
          fill="#FFB882"
        />
        <path
          d="M96.6929 54.7114C93.4995 55.0666 87.7335 56.4877 86.048 56.6653C84.7174 56.843 85.9593 62.7937 87.9996 62.3496C90.0399 61.9056 96.6929 61.1062 97.2252 60.5733C97.6687 60.0404 98.9106 54.4449 96.6929 54.7114Z"
          fill="#FFB882"
        />
        <path
          d="M96.16 42.7204C97.2245 41.6546 96.4261 47.9606 97.9341 48.1382C100.507 48.4935 97.1358 43.2533 97.9341 40.6776C96.6922 39.0789 96.0713 38.1019 95.4503 38.2795C93.2326 38.7236 91.281 41.0329 91.3697 42.3651C91.7246 46.9836 97.5793 50.9804 98.6438 52.4015C98.7325 52.4903 98.8212 52.7567 98.9986 53.112C98.9099 50.8027 93.6761 45.1185 96.16 42.7204Z"
          fill="#FAFFF9"
        />
        <path
          d="M99.8832 58.6187C99.8832 58.6187 99.6171 56.9312 99.351 54.3555C98.9962 54.7996 98.4639 55.066 97.7543 55.3325C97.5768 54.8884 97.222 54.5331 96.6898 54.6219C96.4236 54.6219 96.2462 54.7107 95.9801 54.7107C98.0204 57.02 99.8832 58.6187 99.8832 58.6187Z"
          fill="#FAFFF9"
        />
        <path
          d="M253.525 89.2607C264.791 101.962 274.106 131.449 274.106 131.449L266.388 135.09C266.388 135.09 242.703 111.021 236.494 107.113C227.445 101.429 249.711 84.9086 253.525 89.2607Z"
          fill="#FF9566"
        />
        <path
          d="M273.219 136.778C274.638 137.666 276.59 138.643 277.388 138.643C278.187 138.643 281.735 138.377 282.09 137.666C282.445 136.956 282.178 135.535 281.291 135.002C280.404 134.469 278.364 135.091 277.832 134.913C277.211 134.735 275.082 133.226 275.082 133.226L273.219 136.778Z"
          fill="#FF9566"
        />
        <path
          d="M271.003 142.107C272.423 143.084 274.197 144.15 274.995 144.15C275.794 144.15 279.608 144.061 280.052 143.351C280.495 142.64 280.85 141.219 280.052 140.686C279.164 140.065 276.326 140.597 275.705 140.42C275.173 140.242 273.044 138.555 273.044 138.555L271.003 142.107Z"
          fill="#FF9566"
        />
        <path
          d="M261.246 128.873C262.044 134.024 263.907 141.752 264.972 142.995C266.923 145.393 275.262 152.321 276.415 153.298C277.302 154.008 278.987 150.989 277.923 149.567C277.834 149.479 271.359 142.373 271.359 142.196C271.359 141.752 276.504 136.334 276.06 134.557C275.528 132.692 270.383 128.607 270.028 125.409L261.246 128.873Z"
          fill="#FFB882"
        />
        <path
          d="M271.447 142.196C271.447 142.196 271.447 142.284 271.447 142.196C267.81 141.219 265.148 137.222 265.858 132.426C266.302 129.672 261.156 124.343 256.278 118.57L271.358 123.899C271.801 127.097 276.148 132.87 276.68 134.646C277.124 136.511 271.358 141.752 271.447 142.196Z"
          fill="#FF9566"
        />
        <path
          d="M282.179 134.824C281.47 134.291 279.518 133.758 279.075 134.468C278.542 135.179 278.542 137.577 279.341 137.843C280.139 138.11 281.47 138.11 282.091 137.755C282.712 137.488 282.534 135.09 282.179 134.824Z"
          fill="#FFB882"
        />
        <path
          d="M280.494 140.952C279.961 140.241 278.276 139.264 277.566 139.797C276.945 140.33 276.236 142.639 276.945 143.084C277.566 143.528 278.897 143.883 279.607 143.794C280.316 143.616 280.76 141.307 280.494 140.952Z"
          fill="#FFB882"
        />
        <path
          d="M263.283 138.288C264.968 139.442 269.138 140.863 270.113 140.952C271.089 140.952 275.702 140.952 276.234 140.153C276.766 139.354 277.21 137.755 276.145 136.956C275.081 136.245 271.178 136.6 270.468 136.423C267.275 135.002 267.452 129.761 264.88 130.65C262.13 131.538 261.863 136.156 263.283 138.288Z"
          fill="#FFB882"
        />
        <path
          d="M289.717 12.3456L295.749 8.7041C295.749 8.7041 294.596 10.214 292.378 12.5232C290.161 14.8325 292.112 24.9576 292.112 24.9576L290.782 26.3787C290.782 26.2899 288.209 13.8555 289.717 12.3456Z"
          fill="#DD1F51"
        />
        <path
          d="M290.606 25.3125C293.444 21.7598 300.364 10.48 300.807 9.8583C301.339 9.3254 297.17 7.72669 295.662 7.90433C294.154 8.08196 289.63 12.3452 289.63 12.3452C289.63 12.3452 292.469 10.8353 292.202 12.5228C293.533 11.1906 295.573 8.88131 296.017 9.23658C296.727 9.8583 289.63 25.1348 289.63 25.1348L290.606 25.3125Z"
          fill="#F72D58"
        />
        <path
          d="M300.097 16.1639L306.661 18.8284C306.661 18.8284 304.798 18.7396 301.516 18.3844C298.323 18.0291 291.492 25.5785 291.492 25.5785L289.629 25.4009C289.629 25.4009 298.057 15.8087 300.097 16.1639Z"
          fill="#DD1F51"
        />
        <path
          d="M290.338 24.6017C294.862 24.7793 308.08 23.4471 308.789 23.5359C309.588 23.6247 308.257 19.3615 307.281 18.2957C306.217 17.1411 300.096 16.1641 300.096 16.1641C300.096 16.1641 303.023 17.5851 301.515 18.2957C303.378 18.5621 306.394 18.8286 306.394 19.3615C306.305 20.2496 289.806 23.7135 289.806 23.7135L290.338 24.6017Z"
          fill="#F72D58"
        />
        <path
          d="M260.446 56.0434C247.85 65.8133 236.318 83.932 236.85 102.85C237.116 112.62 256.277 108.268 261.067 101.962C267.809 93.2578 295.486 71.0535 296.373 66.9679C298.591 56.6651 276.325 43.6978 260.446 56.0434Z"
          fill="#FF9566"
        />
        <path
          d="M260.446 56.0435C270.292 48.4053 282.534 50.4481 289.897 55.5995C282.357 53.0238 272.687 53.4678 265.147 60.3068C253.349 70.9648 240.841 90.0605 242.438 108.801C237.914 108.712 234.366 107.113 234.277 103.205C233.833 84.1986 247.761 65.8134 260.446 56.0435Z"
          fill="#FFB882"
        />
        <path
          d="M266.301 135.09C266.301 135.09 241.907 110.31 235.697 106.313C233.391 104.892 242.616 106.402 246.608 109.777C257.697 119.014 265.769 128.251 267.277 134.113L266.301 135.09Z"
          fill="#FFB882"
        />
        <path
          d="M300.099 146.37C288.301 175.325 268.164 209.075 268.164 209.075H266.833L270.47 149.568L300.099 146.37Z"
          fill="#FFB882"
        />
        <path
          d="M268.517 182.341L270.558 149.568L300.186 146.37C294.598 160.226 287.057 175.058 280.67 186.871L268.517 182.341Z"
          fill="#FF9566"
        />
        <path
          d="M307.727 48.8492C332.565 57.1092 341.347 80.1128 341.347 80.1128L339.307 79.8464L343.565 88.1952L341.259 87.3958C355.008 126.12 349.863 146.726 347.202 162.091L342.944 156.229L343.21 164.578L337.888 160.048L336.291 170.44L327.686 167.154L322.009 177.545L316.509 173.193L314.025 177.634L308.259 169.729L303.38 177.634L298.147 171.506L293.8 178.522L285.018 169.196L274.55 176.302L271.712 168.663L266.478 174.614C266.478 174.614 260.978 136.512 262.309 125.143L259.559 130.206C259.559 130.206 257.341 110.932 258.938 103.116L256.454 105.87C257.696 87.7511 255.035 68.3001 265.857 58.9743C271.534 54.0894 299.034 46.007 307.727 48.8492Z"
          fill="#FFBB43"
        />
        <path
          d="M331.767 93.1689C326.711 106.758 314.558 124.521 295.752 131.449C285.994 135.091 282.978 117.327 287.414 111.199C293.534 102.584 305.155 72.5633 308.881 70.2541C318.284 64.5698 338.066 76.116 331.767 93.1689Z"
          fill="#FFAC33"
        />
        <path
          d="M305.863 124.876C293.621 135.979 263.993 146.637 263.993 146.637L262.751 136.867C262.751 136.867 286.081 113.419 289.984 107.113C295.573 98.0536 310.032 121.057 305.863 124.876Z"
          fill="#FFAC33"
        />
        <path
          d="M256.454 105.959C257.696 87.8398 255.035 68.3889 265.857 59.0631C271.534 54.1781 299.034 46.007 307.727 48.9379C332.565 57.1979 341.347 80.2016 341.347 80.2016L339.307 79.9351L343.565 88.2839L341.259 87.4846C355.008 126.209 349.863 146.814 347.202 162.18L346.581 161.292C348.089 152.676 348.799 143.084 348.533 133.137C347.468 94.1458 328.041 52.5794 312.074 61.1947C300.453 67.5007 283.421 139.975 289.453 173.904L284.929 169.107L274.462 176.213L271.623 168.575L266.389 174.525C266.389 174.525 260.889 136.423 262.22 125.054L259.47 130.117C259.47 130.117 257.252 110.843 258.849 103.028L256.454 105.959Z"
          fill="#FFAC33"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M274.105 112.531C272.331 111.643 270.822 110.044 270.556 108.09L270.379 107.38C270.29 106.314 270.468 105.159 270.822 104.182C271.532 102.406 273.129 101.162 274.814 100.452C276.588 99.8302 278.54 99.7414 280.403 100.008C282.355 100.274 284.306 100.896 285.992 101.873C287.056 102.406 288.121 103.205 288.564 104.271C289.451 106.314 288.209 108.623 286.879 110.399C285.637 112.087 284.129 113.775 282.177 114.041C281.379 114.13 280.58 114.041 279.782 113.952C277.919 113.686 275.879 113.419 274.105 112.531Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M276.592 152.676C275.528 153.031 274.374 152.499 273.665 151.788C271.891 150.189 271.536 147.17 272.955 145.216C274.374 143.262 277.479 142.729 279.342 144.239C281.382 145.748 281.648 148.679 281.382 151.166C281.294 151.966 281.027 152.943 280.318 153.209C279.874 153.387 279.431 153.298 278.987 153.209C277.479 152.854 275.971 152.232 274.729 151.255L276.592 152.676Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M287.768 171.328C287.945 169.463 288.921 167.687 290.518 166.799C292.114 165.822 294.332 165.91 295.751 167.065C296.727 167.864 297.348 169.197 297.437 170.529C297.525 171.239 297.526 171.95 297.348 172.661L293.622 178.611L289.364 174.082L287.59 172.216C287.768 171.861 287.768 171.595 287.768 171.328Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M306.399 168.574C306.576 167.953 306.842 167.331 307.197 166.887C307.907 166.088 308.971 165.821 310.036 165.821C311.1 165.821 317.31 164.755 321.124 176.746L321.479 177.367L316.334 173.282L314.028 177.634L308.261 169.729L306.487 172.571C306.132 171.239 306.044 169.907 306.399 168.574Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M265.502 112.353C265.502 112.975 265.414 113.597 265.059 114.219C264.526 115.107 263.551 115.64 262.575 115.906C262.131 115.995 260.623 116.617 258.494 116.084C258.317 111.376 258.317 106.58 258.938 103.472C259.027 103.56 259.204 103.56 259.293 103.649C262.664 105.337 265.591 108.623 265.502 112.353Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M257.696 104.538L256.454 105.959C256.543 104.893 256.543 103.739 256.631 102.673C257.341 102.85 258.051 103.117 258.76 103.472L257.696 104.538Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M275.438 159.16C276.68 159.693 277.833 160.581 278.277 161.825C278.543 162.535 278.454 163.246 278.365 163.956C278.011 167.42 276.148 170.706 273.487 172.927C273.398 172.927 273.398 173.016 273.309 173.016L271.712 168.664L266.479 174.614C266.479 174.614 265.503 167.687 264.438 158.894C267.898 157.473 271.979 157.561 275.438 159.16Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M294.064 89.172C290.605 88.9944 287.234 87.3069 284.927 84.7312L286.081 85.1752C285.548 84.1983 285.371 83.0436 285.194 81.889C284.839 79.6686 284.661 77.3593 285.726 75.4054C287.234 72.4744 291.048 71.4974 294.33 72.0303C298.943 72.7409 303.113 76.0271 304.887 80.3791C305.419 81.6226 305.685 83.0436 305.153 84.1983C304.887 84.9088 304.354 85.4417 303.822 85.8858C301.072 88.195 297.524 89.3497 294.064 89.172Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M290.962 144.505C292.914 143.528 295.131 143.173 297.349 143.351C298.502 143.439 299.744 143.795 300.276 144.772C300.72 145.482 300.543 146.459 300.454 147.259C300.276 148.413 300.01 149.657 299.212 150.634C298.502 151.433 297.349 151.877 296.285 152.055C294.954 152.321 290.519 153.032 289.543 151.966C289.188 151.522 289.01 150.989 288.833 150.456C288.39 148.946 288.123 147.259 289.01 146.015C289.454 145.305 290.164 144.861 290.962 144.505Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M285.107 126.298C286.172 125.143 287.413 124.077 289.01 124.077C289.897 124.077 290.696 124.521 291.405 124.965C293.268 126.12 294.776 127.807 295.752 129.761C296.284 130.738 296.639 131.982 296.018 132.959C295.575 133.669 294.776 134.113 293.978 134.469C292.913 134.913 291.671 135.446 290.518 135.179C289.454 135.002 288.478 134.291 287.768 133.403C286.793 132.426 283.954 129.051 284.309 127.63C284.397 127.097 284.752 126.653 285.107 126.298Z"
            fill="#5E2A3A"
          />
          <path
            opacity="0.5"
            d="M264.085 123.811C265.326 124.078 266.568 124.699 267.189 125.765C267.81 126.831 267.722 128.252 267.101 129.318C266.48 130.384 265.415 131.094 264.262 131.627C263.641 131.893 262.931 132.071 262.222 132.16C262.133 129.407 262.222 127.008 262.399 125.232L259.649 130.295C259.649 130.295 259.383 127.63 259.028 123.989C260.625 123.456 262.399 123.456 264.085 123.811Z"
            fill="#5E2A3A"
          />
        </g>
        <path
          d="M334.162 71.0535C338.42 81.7116 335.581 106.136 328.928 111.643C322.275 117.238 311.364 103.028 308.614 90.238C305.775 77.4484 329.194 58.6191 334.162 71.0535Z"
          fill="#E03F3F"
        />
        <path
          d="M333.455 70.6092C337.536 80.8232 334.786 104.271 328.399 109.6C321.923 114.929 311.367 101.34 308.617 88.9944C305.867 76.7376 328.665 58.7078 333.455 70.6092Z"
          fill="#EA7B59"
        />
        <path
          opacity="0.6"
          d="M310.656 55.333L315.978 67.6785L307.817 64.1258C309.236 71.6753 304.269 83.1327 304.269 83.1327L302.672 77.7149C300.809 84.7314 295.93 92.3697 295.93 92.3697L295.487 87.3071C294.156 92.4585 289.277 97.6099 289.277 97.6099L289.454 94.146C287.059 98.7645 281.471 102.672 281.471 102.672L282.269 99.6527C280.672 100.985 278.898 102.406 277.035 103.827L275.084 99.9191L271.802 104.982L270.648 98.5869L268.785 102.14L264.439 94.8566L262.132 98.5869L260.713 90.3269L258.318 95.3895L256.278 83.7544L253.705 86.3301L253.262 78.9583H253.173C256.899 58.9745 271.624 44.8525 289.277 44.8525C296.285 44.8525 304.269 46.8065 311.809 50.3592C313.583 52.4908 315.002 54.5336 315.889 55.9547L310.656 55.333Z"
          fill="#843131"
        />
        <path
          d="M333.098 83.1327C328.042 96.7217 316.421 113.597 297.615 120.614C287.857 124.255 284.309 107.38 288.744 101.163C294.865 92.5473 306.486 62.5271 310.212 60.2179C319.615 54.5336 339.397 65.991 333.098 83.1327Z"
          fill="#FFB882"
        />
        <path
          d="M305.952 111.82C319.081 99.7412 334.339 79.6685 331.589 66.79C335.048 71.1421 336.734 77.004 334.339 83.6653C330.347 94.501 321.033 107.646 307.904 116.084C301.96 121.413 292.114 122.123 291.67 121.057C291.138 119.903 300.541 116.705 305.952 111.82Z"
          fill="#FF9566"
        />
        <path
          d="M268.783 210.141H256.63C256.63 210.141 266.033 205.079 268.074 205.523C270.203 205.967 268.783 210.141 268.783 210.141Z"
          fill="#FFB882"
        />
        <path
          d="M250.157 44.5855C250.689 42.0987 251.221 39.523 252.019 37.1249L250.866 37.4802C248.737 35.9703 243.77 34.0163 240.044 33.5722C245.1 31.8847 248.915 31.7071 252.197 32.5064C249.003 29.1314 243.326 23.8912 240.044 22.5589C246.963 21.4043 252.019 23.6247 256.189 27.0886C254.414 23.8023 251.221 19.5391 248.382 17.1411C253.35 17.8516 256.81 19.7167 259.471 22.3813C259.471 18.2957 260.89 14.2101 265.148 9.23633C264.261 12.7002 264.172 17.5851 264.705 20.3385C264.971 20.1608 265.237 20.072 265.592 19.8944C267.898 14.4765 271.446 10.7462 278.898 9.23633C276.858 11.3679 274.729 14.743 273.309 17.7628C273.487 17.7628 273.575 17.7628 273.753 17.7628C278.72 15.8976 284.22 15.5423 292.204 18.0292C290.075 18.2069 287.591 18.7398 285.285 19.3615C291.672 21.5819 296.107 25.2234 296.107 25.2234L294.688 26.4668C297.881 28.4208 304.002 30.6413 308.704 31.263C305.776 32.24 303.115 32.8617 300.72 33.1281C304.978 37.9243 310.3 44.0526 312.341 47.5165L307.107 46.8948L312.429 59.2404L304.268 55.6877C305.688 63.2371 300.72 74.6945 300.72 74.6945L299.123 69.2767C297.26 76.2933 292.381 83.9315 292.381 83.9315L291.938 78.8689C290.607 84.0203 285.728 89.1717 285.728 89.1717L285.906 85.7079C283.511 90.3264 277.922 94.2343 277.922 94.2343L278.72 91.2145C277.124 92.5468 275.35 93.9679 273.487 95.3889L271.535 91.481L268.253 96.5435L267.1 90.1487L265.237 93.7014L260.89 86.4184L258.584 90.1487L257.164 81.8887L254.769 86.9513L252.729 75.3163L250.157 77.892L249.713 70.5201L246.076 71.053C247.673 66.7898 248.028 59.1515 249.181 50.8916C247.407 52.135 245.632 53.6449 244.302 55.066C245.81 49.9146 247.761 46.806 250.157 44.5855Z"
          fill="#753949"
        />
        <path
          d="M242.085 33.839C241.375 33.6614 240.754 33.5725 240.133 33.4837C241.73 32.9508 243.238 32.5956 244.569 32.3291C243.682 32.862 242.883 33.3949 242.085 33.839Z"
          fill="#5E2A3A"
        />
        <path
          d="M282.89 21.1378C272.6 21.1378 257.875 25.9339 249.625 29.753C246.52 26.8221 242.706 23.5358 240.133 22.47C247.052 21.3154 252.109 23.5358 256.278 26.9997C254.504 23.7135 251.31 19.4502 248.472 17.0522C253.439 17.7627 256.899 19.6279 259.56 22.2924C259.56 18.2068 260.98 14.1212 265.238 9.14746C264.35 12.6113 264.262 17.4963 264.794 20.2496C265.06 20.072 265.326 19.9831 265.681 19.8055C267.988 14.3877 271.536 10.6574 278.987 9.14746C276.947 11.2791 274.818 14.6541 273.399 17.6739C273.576 17.6739 273.665 17.6739 273.842 17.6739C278.81 15.8087 284.31 15.4535 292.293 17.9404C290.164 18.118 287.681 18.6509 285.374 19.2726C291.761 21.493 296.197 25.1345 296.197 25.1345C296.197 25.1345 288.923 21.1378 282.89 21.1378Z"
          fill="#5E2A3A"
        />
        <path
          d="M276.857 25.2231C276.857 25.2231 287.058 26.2889 294.155 30.108C294.155 30.108 291.316 22.2921 283.066 20.8711C276.058 19.7164 276.857 25.2231 276.857 25.2231Z"
          fill="#5E2A3A"
        />
        <path
          d="M268.605 95.7444L268.25 96.3661L267.895 94.4121C268.073 94.8562 268.339 95.3003 268.605 95.7444Z"
          fill="#5E2A3A"
        />
        <path
          d="M250.157 44.5855C250.689 42.0987 251.221 39.523 252.019 37.1249L250.866 37.4802C248.737 35.9703 243.77 34.0163 240.044 33.5722C245.1 31.8847 248.915 31.7071 252.197 32.5064C249.003 29.1314 243.326 23.8912 240.044 22.5589C246.963 21.4043 252.019 23.6247 256.189 27.0886C254.414 23.8023 251.221 19.5391 248.382 17.1411C253.35 17.8516 256.81 19.7167 259.471 22.3813C259.471 18.2957 260.89 14.2101 265.148 9.23633C264.261 12.7002 264.172 17.5851 264.705 20.3385C264.971 20.1608 265.237 20.072 265.592 19.8944C267.898 14.4765 271.446 10.7462 278.898 9.23633C278.72 9.41396 278.454 9.68041 278.277 9.94687C268.696 18.4733 256.898 34.9933 255.923 55.066C255.302 68.655 260.979 83.8427 266.479 91.3922L265.326 93.7014L260.979 86.4184L258.672 90.1487L257.253 81.8887L254.858 86.9513L252.818 75.3163L250.245 77.892L249.802 70.5201L246.165 71.053C247.761 66.7898 248.116 59.1515 249.269 50.8916C247.495 52.135 245.721 53.6449 244.391 55.066C245.81 49.9146 247.761 46.806 250.157 44.5855Z"
          fill="#5E2A3A"
        />
        <path
          d="M268.254 96.366L271.625 91.481L272.867 83.8428L268.254 96.366Z"
          fill="#5E2A3A"
        />
        <path
          d="M273.489 95.2112L278.634 91.1256L279.876 83.5762L273.489 95.2112Z"
          fill="#5E2A3A"
        />
        <path
          d="M300.098 58.0859C301.251 64.2143 298.945 75.3165 292.38 83.8429C296.283 73.9842 297.791 68.2111 300.098 58.0859Z"
          fill="#5E2A3A"
        />
        <path
          d="M299.035 64.3916C300.365 67.5002 301.075 71.0529 300.809 74.6056C299.922 71.9411 299.123 69.7206 298.325 67.589L299.035 64.3916Z"
          fill="#5E2A3A"
        />
        <path
          d="M278.717 28.5985C278.717 28.5985 287.677 29.8419 293.265 34.194C293.265 34.194 291.757 28.0656 284.572 25.4011C277.475 22.8254 278.717 28.5985 278.717 28.5985Z"
          fill="#5E2A3A"
        />
        <path
          d="M275.794 33.1288C275.794 33.1288 282.358 35.8821 285.818 40.4118C285.818 40.4118 285.907 35.438 280.939 31.9741C276.06 28.4214 275.794 33.1288 275.794 33.1288Z"
          fill="#5E2A3A"
        />
        <path
          d="M252.994 44.6745L265.857 39.4343L268.961 39.3455L272.51 36.5921L279.518 37.0362L279.074 34.3717L288.211 28.5098L270.115 33.3947L256.187 40.1448L252.994 44.6745Z"
          fill="#5E2A3A"
        />
        <path
          d="M283.953 25.5781L249.091 36.2362L249.801 44.585L288.034 28.8644L283.953 25.5781Z"
          fill="#F72D58"
        />
        <path
          d="M282.091 26.112L283.954 25.4902L288.034 28.7765L282.357 31.0857C282.357 29.3982 282.268 27.7107 282.091 26.112Z"
          fill="#E51A4F"
        />
        <path
          d="M257.076 33.8389C256.277 36.681 255.834 39.5232 255.834 42.0989L249.89 44.5857L249.181 36.3257L257.076 33.8389Z"
          fill="#E51A4F"
        />
        <path
          d="M273.131 28.2438C273.131 28.2438 282.002 29.6649 287.59 34.1946C287.59 34.1946 286.171 28.0662 279.163 25.224C271.978 22.3819 273.131 28.2438 273.131 28.2438Z"
          fill="#5E2A3A"
        />
        <path
          d="M276.234 25.7563C276.234 25.7563 285.814 25.4011 292.29 28.6873C292.29 28.6873 289.984 22.9142 282.089 21.5819C274.194 20.2497 276.234 25.7563 276.234 25.7563Z"
          fill="#753949"
        />
        <path
          d="M254.238 45.7401C253.173 47.6052 255.48 50.1809 258.407 49.2039C261.601 48.0493 264.084 43.6973 264.084 43.6973L254.238 45.7401Z"
          fill="#FF9566"
        />
        <path
          d="M254.769 45.4737C253.882 46.9836 255.745 49.0263 258.14 48.227C260.712 47.3388 262.752 43.7861 262.752 43.7861L254.769 45.4737Z"
          fill="#FFB882"
        />
        <path
          d="M277.121 38.9902C280.67 44.941 274.105 46.4509 272.331 46.6285C267.009 47.4279 261.243 44.4969 261.243 44.4969L277.121 38.9902Z"
          fill="#FF9566"
        />
        <path
          d="M274.284 40.6777C276.857 44.941 272.066 46.0068 270.825 46.1844C267.01 46.7173 262.841 44.6745 262.841 44.6745L274.284 40.6777Z"
          fill="#FFB882"
        />
        <path
          d="M266.122 42.81C266.477 43.6094 267.276 44.3199 268.606 43.8759C269.937 43.4318 269.05 41.9219 269.05 41.9219L266.122 42.81Z"
          fill="#471F2C"
        />
        <path
          d="M257.521 44.7632C257.875 45.5625 258.674 46.2731 260.004 45.829C261.335 45.3849 260.448 43.875 260.448 43.875L257.521 44.7632Z"
          fill="#471F2C"
        />
        <path
          d="M281.117 32.6846C271.359 42.2768 249.892 45.6519 249.892 45.6519C257.166 46.096 273.222 43.0762 284.044 35.6155L281.117 32.6846Z"
          fill="#5E2A3A"
        />
        <path
          d="M263.105 45.7402C256.629 46.8949 252.282 53.1121 252.282 53.1121C252.282 53.1121 258.581 51.3357 262.306 49.3817C265.943 47.4278 263.105 45.7402 263.105 45.7402Z"
          fill="#5E2A3A"
        />
        <path
          d="M263.018 46.4512C256.542 47.7834 252.462 54.1783 252.462 54.1783C252.462 54.1783 258.76 52.2243 262.308 50.0927C265.945 47.9611 263.018 46.4512 263.018 46.4512Z"
          fill="#753949"
        />
        <path
          d="M262.577 44.4971C260.714 45.1188 259.738 46.007 260.27 46.984C260.803 47.9609 262.045 48.4938 263.375 48.0498C264.883 47.6057 266.391 45.7405 266.391 45.7405L262.577 44.4971Z"
          fill="#EA7B59"
        />
        <path
          d="M263.019 44.5859C261.422 45.2077 260.624 46.007 260.979 46.8064C261.334 47.6057 262.309 47.8722 263.463 47.5169C264.704 47.0728 266.39 45.5629 266.39 45.5629L263.019 44.5859Z"
          fill="#FFB882"
        />
        <path
          d="M266.034 50.1811C265.945 49.8258 265.324 49.8258 264.792 50.0923C264.171 50.3587 263.816 50.8916 263.905 51.2469C263.994 51.6022 264.349 51.1581 264.97 50.8028C265.591 50.4475 266.123 50.5364 266.034 50.1811Z"
          fill="#4F2031"
        />
        <path
          d="M299.301 45.0303C303.648 53.7344 300.809 74.6064 300.809 74.6064C303.736 68.8333 306.043 57.287 303.559 49.027L299.301 45.0303Z"
          fill="#5E2A3A"
        />
        <path
          d="M292.113 73.9844C291.226 82.1555 285.638 88.9945 285.638 88.9945C288.21 86.9517 293 78.7805 293.533 74.0732L292.113 73.9844Z"
          fill="#5E2A3A"
        />
        <path
          d="M288.477 28.2441C299.654 34.7278 308.613 30.9087 308.613 30.9087C306.041 33.7508 295.13 34.7278 288.654 31.0863L288.477 28.2441Z"
          fill="#5E2A3A"
        />
        <path
          d="M289.454 41.0335C291.672 40.5894 292.559 38.369 291.583 36.5926C290.696 34.9051 288.035 34.8163 286.438 35.9709C284.842 37.1255 289.454 41.0335 289.454 41.0335Z"
          fill="#FF865C"
        />
        <path
          d="M289.185 39.9671C290.516 39.7006 291.137 38.2796 290.516 37.2138C289.984 36.1479 288.298 36.1479 287.322 36.8585C286.347 37.4802 289.185 39.9671 289.185 39.9671Z"
          fill="#CE5236"
        />
        <path
          d="M288.477 39.612C289.275 39.4344 289.63 38.635 289.275 37.9245C288.92 37.3027 287.945 37.3027 287.324 37.658C286.791 38.1021 288.477 39.612 288.477 39.612Z"
          fill="#FF865C"
        />
        <path
          d="M266.3 45.2075C272.421 42.7206 279.34 45.8292 279.34 45.8292C279.34 45.8292 273.042 47.6055 268.873 47.872C264.792 48.1384 266.3 45.2075 266.3 45.2075Z"
          fill="#5E2A3A"
        />
        <path
          d="M266.303 45.7407C272.424 43.5203 279.343 46.7177 279.343 46.7177C279.343 46.7177 273.045 48.3164 268.875 48.494C264.617 48.6717 266.303 45.7407 266.303 45.7407Z"
          fill="#753949"
        />
        <path
          d="M260.271 50.4473L255.746 54.6217L250.513 55.8651C252.997 52.9341 256.545 51.5131 260.271 50.4473Z"
          fill="#5E2A3A"
        />
        <path
          d="M276.503 65.9019L274.374 59.507L273.931 52.9346C275.439 56.5761 276.06 61.1057 276.503 65.9019Z"
          fill="#5E2A3A"
        />
        <path
          d="M263.816 48.849C262.841 49.3819 262.042 50.0924 261.599 50.8029C261.865 50.8029 262.042 50.8918 262.308 50.8918C262.574 50.4477 262.929 50.0036 263.55 49.6483C265.679 48.4049 269.139 49.3819 268.695 51.6023L270.115 51.3358C270.824 47.9608 266.921 47.0726 263.816 48.849Z"
          fill="#4F2031"
        />
        <path
          d="M272.689 27.4443C272.689 27.4443 280.495 28.4213 285.462 32.0628C285.462 32.0628 284.043 26.8226 277.834 24.6022C271.535 22.3818 272.689 27.4443 272.689 27.4443Z"
          fill="#753949"
        />
        <path
          d="M287.768 120.436C279.341 106.225 275.704 77.3594 275.704 77.3594L284.574 75.7607C284.574 75.7607 302.937 103.294 308.348 108.357C316.154 115.64 290.695 125.232 287.768 120.436Z"
          fill="#FFB882"
        />
        <path
          d="M278.101 89.2606C275.617 84.198 274.908 80.7342 274.109 79.846C272.069 77.4479 267.456 76.7374 264.884 74.8722C263.464 73.8952 260.182 66.9675 265.327 67.3228C267.634 67.5004 270.916 70.6978 273.577 69.5432C275.706 68.655 278.013 67.1451 280.674 69.1879C282.448 70.609 284.577 76.5597 288.214 81.8L278.101 89.2606Z"
          fill="#FFB882"
        />
        <path
          d="M268.521 68.7437C267.545 65.5463 266.746 63.5035 267.367 61.7271C267.9 59.9508 272.246 60.3061 272.867 59.3291C273.488 58.4409 273.133 56.4869 272.158 56.1317C271.182 55.8652 265.15 58.1744 264.263 58.7962C263.464 59.4179 260.98 66.2568 261.335 69.1878C261.956 74.428 269.762 72.9181 268.521 68.7437Z"
          fill="#FFB882"
        />
        <path
          d="M274.729 73.628C271.891 71.8516 270.028 70.7858 269.318 69.0983C268.608 67.4108 271.979 64.7463 271.891 63.5916C271.802 62.437 270.205 61.2824 269.318 61.6377C268.431 62.0818 265.415 67.8549 265.238 68.9207C265.06 69.9865 266.568 73.8944 268.786 75.9372C272.423 79.4011 278.366 75.8484 274.729 73.628Z"
          fill="#FFB882"
        />
        <path
          d="M270.827 72.2079C267.9 70.5204 266.037 69.4546 265.238 67.767C264.44 66.0795 267.9 63.415 267.722 62.3492C267.545 61.1946 265.948 60.04 265.061 60.484C264.174 60.9281 261.247 66.7012 261.069 67.6782C260.892 68.744 262.488 72.652 264.795 74.606C268.698 77.981 274.641 74.4283 270.827 72.2079Z"
          fill="#FFB882"
        />
        <path
          d="M281.47 71.142C282.535 69.0992 277.478 65.4577 277.212 64.6583C276.68 63.2373 276.857 59.951 276.591 58.7076C276.325 57.553 273.664 58.1747 273.22 58.5299C272.511 59.0628 272.599 62.6155 272.865 63.9478C273.132 65.1912 273.664 68.1222 272.244 70.165C269.672 73.7177 278.454 77.1815 281.47 71.142Z"
          fill="#FFB882"
        />
        <path
          d="M303.29 117.593C306.306 116.439 308.08 114.662 308.257 112.619C308.435 111.021 307.548 109.6 305.862 108.623C303.733 107.379 300.983 108.534 299.475 110.31C298.322 111.642 298.056 113.152 298.854 114.04C299.83 115.195 301.427 115.639 302.758 115.106C303.999 114.662 304.709 113.419 304.62 111.998H303.733C303.733 113.152 303.29 113.952 302.403 114.307C301.427 114.662 300.274 114.396 299.475 113.419C298.854 112.708 299.475 111.554 300.096 110.843C301.427 109.333 303.645 108.267 305.419 109.333C306.749 110.133 307.459 111.287 307.37 112.531C307.193 114.218 305.596 115.728 302.935 116.794L303.29 117.593Z"
          fill="#EA7B59"
        />
        <path
          d="M382.775 210.408H0C0 210.408 78.3291 219.912 201.278 219.912C324.227 219.912 382.775 210.408 382.775 210.408Z"
          fill="#BAA902"
        />
      </g>
      <defs>
        <clipPath id="clip0_4758_20467">
          <rect width="392.35" height="266" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FAQsBannerVector;
